export default __webpack_public_path__ + "static/media/bg-patrimonial-produto.488b5dd1.webp";